<template>
  <div>
    <button class="btn btn-link p-0" type="primary" @click="showModal">View Details</button>
    <a-modal
    v-model="visible"
    :title="parentData.first_name + ' ' + parentData.last_name + ' (' + parentData.relation.charAt(0).toUpperCase() + parentData.relation.slice(1) + ')'"
    :width="960"
    style="top: 20px;"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
      </template>
      <!-- Basic Details -->
        <div>
            <div class="mb-2">
                <p class="h6 text-muted">Basic Details:</p>
            </div>
            <div class="row">
                <div class="col-6 col-md-4 pb-3" v-for="(item, index) in basicInfo" :key="index">
                    <div class="mb-1">{{index}} :</div>
                    <div>
                        <strong class="h5 font-weight-bold">{{item}}</strong>
                    </div>
                </div>
            </div>
            <a-divider />
        </div>
        <!-- Contact Details -->
        <div class="pt-3">
            <div class="mb-2">
                <p class="h6 text-muted">Contact Details:</p>
            </div>
            <div class="row">
                <div class="col-6 col-md-4 pb-3" v-for="(item, index) in contactInfo" :key="index">
                    <div class="mb-1">{{index}} :</div>
                    <div>
                        <strong class="h5 font-weight-bold">{{item}}</strong>
                    </div>
                </div>
            </div>
        </div>
    </a-modal>
  </div>
</template>

<script>
import { basicInfo, contactInfo } from './data'

export default {
  name: 'ShowParent',
  props: ['parentData'],
  data: function() {
    return {
      loading: false,
      visible: false,
      basicInfo: {},
      contactInfo: {},
    }
  },
  methods: {
    showModal() {
      this.visible = true
      this.basicInfo = basicInfo(this.parentData)
      this.contactInfo = contactInfo(this.parentData.contact)
    },

    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
